import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaCEP } from './types';

export const INITIAL_STATE: ConsultaCEP = {
	status: 0,
	data: null,
};

export default function consultaCEPReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaCEP {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CEP_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTA_CEP_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_CEP_FAILURE: {
				draft.status = 400;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_CEP_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
